import React, { useState, useEffect } from "react";
import { Card, Input, Button, Form, message, Spin, Row, Col } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import "./VerifyPassword.css";
import logoImage from "../../assets/images/dashboard-vector.png";
import HTTP from "../../services/httpService";
import { encrypt } from "../../services/util";

const FormItem = Form.Item;

function ConfirmPassword() {
    const [mainLoader, setMainLoader] = useState(true);
    const [responseData, setResponseData] = useState(null);
    const navigate = useNavigate();
    const { search } = useLocation();

    async function fetchMyAPI() {
        try {
            const response = await HTTP(
                `users/verifyPassword?request_id=${getUrlParameter(
                    "request_id",
                )}&token=${getUrlParameter("token")}`,
                {},
                "GET",
            );
            setMainLoader(false);
            if (response.success) {
                setResponseData(response.data);
                navigate("/verify-password");
            } else {
                // navigate("/link-expired");
            }
        } catch (error) {
            // navigate("/link-expired");
            setMainLoader(false);
        }
    }

    useEffect(() => {
        fetchMyAPI();
    }, []);

    const getUrlParameter = (nameField) => {
        let name = nameField;
        name = name.replace(/[\\[]/, "\\[").replace(/[\\]]/, "\\]");
        const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
        const results = regex.exec(search);
        return results === null
            ? ""
            : decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    async function handleUpdatePasswordSubmit(values) {
        const params = {
            request_id: responseData.request_id,
            user_id: responseData.user_id,
            password: encrypt(values.password),
        };
        const response = await HTTP("/users/verifyPassword", params);
        if (!response.success) {
            message.error("Password update failed");
        } else {
            message.success(response.message, 3);
            navigate("/");
        }
    }

    return (
        <div className="forget-container">
            <Card bordered={false} className="forget-card">
                <Col md={12}>
                    <div>
                        <img
                            src={logoImage}
                            alt="dashboard"
                            className="forget-dashboard-vector"
                        />
                    </div>
                </Col>
                <Col md={12}>
                    <div className="forget-contents">
                        <div className="title-container">
                            Reset Your Password
                        </div>
                        <div className="description-container">
                            Please set new password.
                        </div>
                        <div className="forget-inputs">
                            <Spin spinning={mainLoader}>
                                <Form
                                    layout="vertical"
                                    onFinish={(values) =>
                                        handleUpdatePasswordSubmit(values)
                                    }
                                >
                                    <FormItem required={false}>
                                        <Input
                                            disabled
                                            value={
                                                responseData &&
                                                responseData.email
                                            }
                                            size="large"
                                            placeholder="Email"
                                        />
                                    </FormItem>

                                    <FormItem
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please enter your password.",
                                            },
                                            {
                                                pattern:
                                                    /^(?=.*\d)(?=.*[~!@#$%^&*()\-_=+<>,.?/;:"'{}|\\[\]])(?!.*\s)(?=.*[A-Z])(?=.*[a-z]).{8,16}$/,
                                                message:
                                                    "Password must be 8-16 characters long and contain at least one lowercase letter, one uppercase letter, one special character and a number.",
                                            },
                                        ]}
                                    >
                                        <Input.Password
                                            autoFocus
                                            size="large"
                                            type="password"
                                            placeholder="Password"
                                            className="change-background"
                                        />
                                    </FormItem>

                                    <FormItem
                                        name="confirm_password"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please confirm your password.",
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(rule, value) {
                                                    if (
                                                        !value ||
                                                        getFieldValue(
                                                            "password",
                                                        ) === value
                                                    ) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        "Password does not match.",
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password
                                            size="large"
                                            type="password"
                                            placeholder="Confirm Password"
                                            className="change-background"
                                        />
                                    </FormItem>

                                    <div className="button-link-container">
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                        >
                                            Reset Password
                                        </Button>
                                    </div>
                                </Form>
                            </Spin>
                        </div>
                    </div>
                </Col>
            </Card>
        </div>
    );
}

export { ConfirmPassword };
